import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobsComponent as JobsListComponent } from './jobs-list/jobs-list.component';
import { NewJobDialogComponent } from './new-job-dialog/new-job-dialog.component';
import { SchedulerFileDownloadComponent } from './scheduler-file-download/scheduler-file-download.component';
import { SharedComponentsModule } from 'src/app/shared/shared-components/shared-components.module';
import { MatIconModule } from '@angular/material/icon';
import { SsSchedModule } from '../../ss-sched/ss-sched.module';

@NgModule({
  declarations: [
    JobsListComponent,
    NewJobDialogComponent,
    SchedulerFileDownloadComponent,

  ],
  imports: [
    CommonModule,
    MatIconModule,
    SharedComponentsModule,
    SsSchedModule
  ],
  exports: [
    JobsListComponent,
    NewJobDialogComponent,
    SchedulerFileDownloadComponent
  ]
})
export class SchedulerComponentsModule { }
